<button *ngIf="appcues==false" mat-icon-button (click)="infoClick()" [id]="buttonName" [class]="class"
    [tabindex]="tabIndex">
    <mat-icon>info_outline</mat-icon>
</button>